
import { ToggleButton, ToggleButtonGroup, toggleButtonGroupClasses } from '@mui/material';
import { makeStyles, Theme, withStyles, createStyles, styled } from '@mui/material/styles';


interface Option<T> {
    value: T;
    label: string;
}
interface Props<T = number> {
    value: T;
    options: Option<T>[];
    onChange: (value: T) => void;
}



// const StyledToggleButtonGroup1 = withStyles((theme: Theme) => ({
//     grouped: {
//         margin: theme.spacing(0.5),
//         padding: '2px',
//         minWidth: '40px',
//         textTransform: 'none',
//         background: '#f8f8ff',
//         border: 'none',
//         '&:not(:first-child)': {
//             borderRadius: theme.shape.borderRadius,
//         },
//         '&:first-child': {
//             borderRadius: theme.shape.borderRadius,
//         },
//     },
//     root: {
//         '& .Mui-selected': {
//             background: '#46d06d',
//             color: 'white',
//         },
//     }

// }), { name: "StyledToggleButtonGroup" })(ToggleButtonGroup);


const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        margin: theme.spacing(0.5),
        border: 0,
        borderRadius: theme.shape.borderRadius,
        [`&.${toggleButtonGroupClasses.disabled}`]: {
            border: 0,
        },
    },
    [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
        marginLeft: -1,
        borderLeft: '1px solid transparent',
    },
}));


// const useStyles = makeStyles((theme: Theme) =>  // WAY-2
//     createStyles({
//         selectedButton: {
//             backgroundColor: '#46d06d !important',
//             color: 'white !important',
//         }
//     }),
// );

export function ToggleButtonsMultiple(props: Props) {
    const { value, options, onChange } = props;
    const handleOnChange = (value: number) => {
        if (typeof value === "number") {
            onChange(value)
        }
    }

    // const classes = useStyles();  // WAY-2

    return (
        <StyledToggleButtonGroup size="small" color="primary"
            value={value} onChange={(e: any, value: number) => handleOnChange(value)}
            // aria-label="totals-timeframe"
            exclusive >

            {options.map((frame) =>

                <ToggleButton key={frame.value} value={frame.value} aria-label={frame.label}
                // classes={{ selected: classes.selectedButton }}  // WAY-2
                >
                    {frame.label}
                </ToggleButton>
            )}

        </StyledToggleButtonGroup>
    );
}
